import { Product } from "@/types/product";
import { sendToGoogleTagManager } from "./gtm";
import { sendToYandexMetrica } from "./ym";
import { sendToTiktokPixel } from "./ttq";
import { GiftBox } from "@/types/giftbox";
import { Lookbook } from "@/types/lookbook";

export type EventProduct =
  | (Product & {
      quantity?: number;
    })
  | (GiftBox & {
      quantity?: number;
      price?: number;
      category?: {
        name?: string;
      };
    })
  | (Lookbook & {
      quantity?: number;
      price?: number;
      category?: {
        name?: string;
      };
    });

export type AdditionalData = {
  from?: string;
};

export type MetricsEventMap = {
  session_start: {
    userId?: number | null;
  };
  page_view: {
    url: string;
  };
  view_item_list: {
    products: EventProduct[];
  } & AdditionalData;
  view_item: {
    product: EventProduct;
  } & AdditionalData;
  add_to_cart: {
    from: string;
    product: EventProduct;
  } & AdditionalData;
  remove_from_cart: {
    product: EventProduct;
  } & AdditionalData;
  add_to_favorites: {
    product: EventProduct;
  } & AdditionalData;
  remove_from_favorites: {
    product: EventProduct;
  } & AdditionalData;
  order_status_check: null;
  begin_checkout: {
    userId?: number;
    total: number;
    products: EventProduct[];
  };
  add_shipping_info: {
    shippingMethod: string;
    products: EventProduct[];
  };
  add_payment_info: {
    paymentMethod: string;
    products: EventProduct[];
  };
  purchase: {
    orderId: number | string;
    value?: number;
    tax?: number;
    shipping?: number;
    shippingMethod?: string;
    status?: string;
    products?: EventProduct[];
    transaction_id?: string;
  };
  repeat_purchase: {
    userId: number;
  };
  return_initiated: {
    orderId: number;
  };
  kaspi_pay_success: {
    orderId: number;
  };
  kaspi_pay_failed: {
    orderId: number;
  };
};

export type MetricsEvent = {
  [K in keyof MetricsEventMap]: MetricsEventMap[K] extends null
    ? { type: K }
    : { type: K; data: MetricsEventMap[K] };
}[keyof MetricsEventMap];

export const analytics = {
  trackEvent: async (event: MetricsEvent) => {
    if (typeof window === "undefined") return;

    try {
      sendToGoogleTagManager(event);
    } catch (error) {
      console.error(error);
    }

    try {
      sendToYandexMetrica(event);
    } catch (error) {
      console.error(error);
    }

    try {
      sendToTiktokPixel(event);
    } catch (error) {
      console.error(error);
    }
  },
};
